export enum ScoutEmptyStateMode {
  FilePicker = 'filePicker',
  UploadPage = 'uploadPage',
}
